/** Необязательное текстовое поле формы → значение для API: пустое и пробелы — null. */
export function blankToNull(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed === undefined || trimmed === '' ? null : trimmed; // не ??: "" тоже пусто
}
